import styled from 'styled-components';

const AffixContainer = styled.div`
  display: flex;
  align-items: center;
  :last-of-type {
    padding-inline-end: var(--btn-internals-thin-padding);
  }
  :first-of-type {
    padding-inline-start: var(--btn-internals-thin-padding);
  }
  :only-of-type {
    padding-inline: max(
      (var(--btn-size) - 1.5rem) / 2,
      var(--btn-size) * 0.125
    );
  }
`;

export default AffixContainer;
